import {countDecimals, roundNumber} from './mathFunctions';

export function getDefaultEachWayString() {
    return "1/4";
}

export function calculateEachWayValuesFirstOrPlaced(originalStake, originalOdd, eachWayRatio, firstPlace) {

    let eachWayRatioNumber = eachWayRatio === undefined ? Number('4') : eachWayRatio.substring(eachWayRatio.indexOf('/') + 1);

    let potentialReturns = 0;
    let stakeDecimals = Math.pow(10, countDecimals(originalStake));
    let oddsDecimals = Math.pow(10, countDecimals(originalOdd));
    let stake = parseFloat(parseFloat(originalStake) * stakeDecimals).toFixed(0);
    let odd = parseFloat(parseFloat(originalOdd) * oddsDecimals).toFixed(0);
    let correspondentEWBetOdd = (((odd - (1 * oddsDecimals)) / (oddsDecimals * eachWayRatioNumber)) + 1);
    let eWBetOddDecimals = Math.pow(10, countDecimals(correspondentEWBetOdd));
    correspondentEWBetOdd = parseFloat(parseFloat(correspondentEWBetOdd) * eWBetOddDecimals).toFixed(0);
    let potentialReturnsWinner = 0, potentialReturnEw, potentialReturnEwDecimals, potentialReturnsWinnerDecimals = 0;

    potentialReturnEw = (parseFloat(stake) * correspondentEWBetOdd) / (stakeDecimals * eWBetOddDecimals);
    potentialReturnEwDecimals = countDecimals(potentialReturnEw);

    if (firstPlace) {
        potentialReturnsWinner = parseFloat(stake) * parseFloat(odd) / (oddsDecimals * stakeDecimals);
        potentialReturnsWinnerDecimals = countDecimals(potentialReturnsWinner);
    }
    let finalDecimals;
    if (potentialReturnEwDecimals > potentialReturnsWinnerDecimals) {
        finalDecimals = Math.pow(10, potentialReturnEwDecimals);
    } else {
        finalDecimals = Math.pow(10, potentialReturnsWinnerDecimals);
    }
    potentialReturns = parseFloat((potentialReturnsWinner * finalDecimals) + (potentialReturnEw * finalDecimals)).toFixed(0);
    potentialReturns = roundNumber(potentialReturns / finalDecimals, 2);

    // EW stake is the original stake multiplied by 2
    let totalStake = Number(originalStake) * 2;

    return {
        totalStake: totalStake,
        potentialReturns: potentialReturns
        /*total stake
        total potentialreturns*/
    }

}

export function calculateEachWayValues(originalStake, originalOdd, eachWayRatio) {
    return calculateEachWayValuesFirstOrPlaced(originalStake, originalOdd, eachWayRatio, true);
}



// WEBPACK FOOTER //
// ./src/helpers/eachWayBetHelpers.js